<template>
	<td class="lv-table-head-cell" :colspan="col.colspan" :rowspan="col.rowspan" @click="lv_click">
		<lv-table-cell
			:class="{'lv-table-cell-group':col.group}"
			:is-fixed="fixed === col.fixed"
			:height="headRowHeight"
			:width="col.width"
			:align="col.align">
			<link-table-cell-normal head :scope-slot-func="col.titleScopedSlot" :text="col.title" :data="{col,colIndex}"/>
			<div class="lv-table-head-cell-sort" :class="classes" v-if="!!col.sort">
				<link-icon icon="icon-triangle-up1" class="lv-sort-asc-icon"/>
				<link-icon icon="icon-triangle-down1" class="lv-sort-desc-icon"/>
			</div>
		</lv-table-cell>
		<div v-if="col.fixed === fixed"
			 class="lv-table-head-cell-drag"
			 @mousedown="lv_mousedown"></div>
	</td>
</template>

<script>
import LvTableCell from "./lv-table-cell";
import {TableMixin} from "./index";

export default {
	name: "lv-table-head-cell",
	components: {LvTableCell},
	mixins: [TableMixin],
	props: {
		col: {},                                //渲染的列信息（有可能是列组）
		colIndex: {},
	},
	inject: ['baseTable'],
	data() {
		return {
			indicator: null,
			startX: null,
			endX: null,
		}
	},
	computed: {
		classes() {
			return {
				[`lv-table-head-cell-sort-${!!this.sortDesc ? 'desc' : 'asc'}`]: this.sortField === this.col.field
			}
		},
		dragColumn() {
			function iterate(column) {
				if (!!column.group) {
					return iterate(column.children[column.children.length - 1])
				} else {
					return column
				}
			}

			return iterate(this.col)
		},
	},
	methods: {
		lv_click() {
			this.baseTable.$emit('clickTitle', {col: this.col})
		},
		lv_mousedown(e) {
			this.startX = e.clientX
			document.addEventListener('mousemove', this.lv_mousemove)
			document.addEventListener('mouseup', this.lv_mouseup)
			this.$lv.$dom.enableSelectNone()
			this.indicator = document.createElement('div')
			this.indicator.style.width = `${e.target.offsetWidth}px`
			this.indicator.style.backgroundColor = '#ddd'
			this.indicator.style.zIndex = 1
			this.indicator.style.height = `${this.baseTable.$el.offsetHeight}px`
			this.indicator.style.display = 'inline-block'
			this.indicator.style.position = 'absolute'
			this.indicator.style.top = `${this.baseTable.$el.getBoundingClientRect().top}px`
			this.indicator.style.left = `${e.clientX - e.target.offsetWidth / 2}px`
			this.indicator.style.zIndex = `9999`
			document.body.appendChild(this.indicator)
		},
		lv_mousemove(e) {
			this.indicator.style.left = `${e.clientX}px`
		},
		lv_mouseup(e) {
			document.removeEventListener('mousemove', this.lv_mousemove)
			document.removeEventListener('mouseup', this.lv_mouseup)
			this.$lv.$dom.disabledSelectNone()
			document.body.removeChild(this.indicator)
			this.endX = e.clientX
			let durX = this.endX - this.startX
			let width = this.dragColumn.width
			width = width + durX
			width = width > 30 ? width : 30
			this.dragColumn.width = width
		},
	}
}
</script>

<style lang="scss">
.lv-table-head-cell {
	position: relative;
	transition: all 150ms linear;

	&:hover {
		background-color: $base-table-head-hover-color;
		cursor: pointer;

		.lv-table-head-cell-sort {
			opacity: 1;
		}
	}

	.lv-table-head-cell-drag {
		width: 8px;
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		background-color: transparent;
		cursor: w-resize;
	}

	.lv-table-cell {
		font-weight: 500;

		&.lv-table-cell-align-right {
			padding-left: 0;

			.lv-table-head-cell-sort {
				left: 0;
				right: initial;
			}
		}
	}

	.lv-table-cell-normal {
		flex: 1;
	}

	.lv-table-head-cell-sort {
		position: absolute;
		right: 4px;
		top: 0;
		bottom: 0;

		width: fit-content;
		display: inline-flex;
		vertical-align: middle;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		font-size: 12px;
		color: $base-table-head-icon-color;
		opacity: 0;

		&.lv-table-head-cell-sort-asc, &.lv-table-head-cell-sort-desc {
			opacity: 1;
		}

		&.lv-table-head-cell-sort-asc {
			.lv-sort-asc-icon {
				color: $base-table-head-icon-active-color;
			}
		}

		&.lv-table-head-cell-sort-desc {
			.lv-sort-desc-icon {
				color: $base-table-head-icon-active-color;
			}
		}
	}

	.lv-sort-desc-icon {
		position: relative;
		top: -4px;
	}

	.lv-sort-asc-icon {
		position: relative;
		top: 4px;
	}

	.lv-table-cell-group {
		border-bottom: solid $auto-table-border-color 1px;
	}
}
</style>
